import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";

export interface Props {
  onExcludeChange: (id: string) => void;
  onRevertExcludedChange: (id: string) => void;
  onCancelEditing: (id: string) => void;
  onApplyChanges: (id: string) => void;
  onPreviewFileContainerFile: (fileContainerId: string, fileName: string) => void;
}

export const DataImportChangesListActionsContext = createContext<Props | undefined>(undefined);

export const useDataImportChangesListActionsContext = () =>
  defined(
    use(DataImportChangesListActionsContext),
    "Attempt to use DataImportChangesListActionsContext without provider"
  );
